import { render } from "./ShippingSection.vue?vue&type=template&id=138b1cd6"
import script from "./ShippingSection.vue?vue&type=script&lang=js"
export * from "./ShippingSection.vue?vue&type=script&lang=js"

import exportComponent from "Z:\\Backups\\Backup Site tecmar\\07.10.2026\\tecmar-transportes-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__